// src/pages/dashboard/agent/NanniesList.jsx
import { useState, useEffect } from 'react';
import { Check, X, Eye } from 'lucide-react';
import api from '../../../../lib/api';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import RatingDisplay from '../../../../components/common/RatingDisplay';

export default function AgentNanniesList() {
  const [nannies, setNannies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get('/agent/my-nannies').then(res => {
      setNannies(res.data.data || res.data);
      setLoading(false);
    });
  }, []);

  const completeVetting = async (id) => {
    const comments = prompt('Vetting comments (optional):');
    try {
      await api.post(`/agent/nannies/${id}/complete-vetting`, { comments });
      alert('Vetting completed!');
      setNannies(prev => prev.filter(n => n.id !== id));
    } catch { alert('Failed'); }
  };

  if (loading) return <LoadingSpinner size="lg" text="Loading your nannies..." />;

  return (
    <div className="space-y-8">
      <h1 className="text-4xl font-bold">My Assigned Nannies</h1>

      <div className="grid gap-6">
        {nannies.map(nanny => (
          <div key={nanny.id} className="bg-white rounded-xl shadow p-8 flex justify-between items-center">
            <div>
              <h3 className="text-2xl font-bold">{nanny.full_name}</h3>
              <p><RatingDisplay rating={nanny?.rating} /></p>                                                                          
              <p className="text-gray-600">{nanny.phone_number}</p>
              <p className="text-sm text-gray-500 mt-2">
                Assigned: {new Date(nanny.pivot?.created_at).toLocaleDateString()}
              </p>
            </div>
            <div className="flex gap-4">
              <button
                onClick={() => setSelected(nanny)}
                className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 flex items-center gap-2"
              >
                <Eye size={20} /> View Profile
              </button>
              <button
                onClick={() => completeVetting(nanny.id)}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center gap-2"
              >
                <Check size={20} /> Complete Vetting
              </button>
            </div>
          </div>
        ))}
      </div>

      {selected && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setSelected(null)}>
          <div className="bg-white rounded-2xl p-10 max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <h2 className="text-3xl font-bold mb-6">{selected.full_name} - Full Profile</h2>
            {/* You can expand this with qualifications, guarantor, etc. */}
            <pre className="bg-gray-100 p-4 rounded-lg text-sm overflow-x-auto">
              {JSON.stringify(selected, null, 2)}
            </pre>
            <button
              onClick={() => setSelected(null)}
              className="px-6 py-3 bg-gray-300 rounded-lg mt-6"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}